import React, {ForwardedRef, forwardRef, useImperativeHandle, useRef, useState} from 'react';
import classNames from 'classnames';
import {observer} from "mobx-react-lite";


import {IconProps} from "../icons";


import {SearchIcon} from "../icons/SearchIcon";
import {CloseIcon} from "../icons/CloseIcon";


import './InputWithClear.css';


export interface InputWithClearProps {
    value: string,
    onChange: (newValue: string) => void,
    placeholder: string,
    className?: string,
    isDarK?: boolean,
    isRequired?: boolean,
    Icon?: React.ComponentType<IconProps> | null;
    withBackground?: boolean,
    maxWidth?: number
}

export const InputWithClear = observer(forwardRef<HTMLInputElement, InputWithClearProps>(
    ({
         value,
         onChange,
         placeholder,
         className,
         isDarK,
         withBackground,
         maxWidth,
         isRequired = false,
         Icon = SearchIcon,
     }: InputWithClearProps, ref: ForwardedRef<HTMLInputElement>) => {

        const [isFocused, setIsFocused] = useState(false);
        const inputRef = useRef<HTMLInputElement>(null);

        // Forward the input ref to the parent
        useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

        const handleClear = () => {
            onChange('');
            inputRef.current?.focus();
        };

        return (
            <div
                style={{maxWidth: maxWidth}}
                className={classNames({
                    "inputWithClear": true,
                    "inputWithClear--withBackground": withBackground,
                    "inputWithClear--isFocused": isFocused,
                    "inputWithClear--withoutIcon": !Icon,
                    "theme-dark": isDarK,
                    [className!]: className
                })}>
                {Icon && <Icon className={'inputWithClear__icon'} size={20}/>}
                <input
                    ref={inputRef}
                    type="text"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    className={classNames({
                        "inputWithClear__input body-large": true,
                        "inputWithClear--withBackground": withBackground,
                    })}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    required={isRequired}
                />
                <CloseIcon
                    onClick={handleClear}
                    size={20}
                    className={classNames({
                        "inputWithClear__CloseIcon": true,
                        "inputWithClear__CloseIcon--hidden": !value
                    })}
                />
            </div>
        );
    })
);
